import { render } from "./app-footer.vue?vue&type=template&id=30a13ce7&scoped=true&ts=true"
import script from "./app-footer.vue?vue&type=script&lang=ts"
export * from "./app-footer.vue?vue&type=script&lang=ts"

import "./app-footer.vue?vue&type=style&index=0&id=30a13ce7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a13ce7"]])

export default __exports__